import React from 'react';
import { Search } from 'lucide-react';
import Pagination from './Pagination';


function Table({ 
  data, 
  columns, 
  searchable = true,
  searchTerm = '',
  onSearchChange,
  emptyMessage = 'No data available',
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  itemsPerPage = 10,
  totalItems = 0
}) {
  return (
    <div className="space-y-6 animate-fadeIn">
      {searchable && (
        <div className="relative group max-w-md">
          <div className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-[#1B6CA8] transition-colors duration-300">
            <Search size={18} />
          </div>
          <input
            type="text"
            placeholder="Search within directory..."
            value={searchTerm}
            onChange={(e) => onSearchChange?.(e.target.value)}
            className="w-full pl-12 pr-4 py-3.5 bg-white border border-slate-200 rounded-[1.25rem] focus:ring-4 focus:ring-[#1B6CA8]/10 focus:border-[#1B6CA8] outline-none transition-all duration-300 font-medium text-slate-700 premium-shadow"
          />
        </div>
      )}

      <div className="bg-white rounded-[2rem] shadow-xl shadow-slate-200/50 border border-slate-100 overflow-hidden premium-shadow">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-slate-100">
            <thead className="bg-slate-50/50">
              <tr>
                {columns.map((column) => (
                  <th
                    key={String(column.key)}
                    className="px-8 py-5 text-left text-[11px] font-black text-slate-400 uppercase tracking-widest"
                  >
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-slate-50">
              {data.length === 0 ? (
                <tr>
                  <td colSpan={columns.length} className="px-8 py-20 text-center">
                    <div className="flex flex-col items-center gap-3">
                      <div className="p-4 bg-slate-50 rounded-full">
                        <Search size={32} className="text-slate-200" />
                      </div>
                      <p className="text-slate-400 font-bold italic tracking-tight">{emptyMessage}</p>
                    </div>
                  </td>
                </tr>
              ) : (
                data.map((item, index) => (
                  <tr key={item.id || item._id || index} className="hover:bg-blue-50/30 transition-colors duration-200 group">
                    {columns.map((column) => (
                      <td key={String(column.key)} className="px-8 py-5 text-sm text-slate-700">
                        {column.render 
                          ? column.render(item)
                            : <span className="font-semibold">{String(item[column.key] || '')}</span>
                        }
                      </td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        {onPageChange && (
          <div className="px-8 py-5 bg-slate-50/50 border-t border-slate-100">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
              itemsPerPage={itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        )}
      </div>
    </div>

  );
}

export default Table;